/* =======================================================================
 * Bespoky Wave 2 Fixes — Sprint 127 (May 18, 2026)
 * SANITIZED Sprint 133 (May 19, 2026):
 *   - REMOVED buildSearchTypeahead() entirely (it wrapped header search
 *     inputs and was the root cause of the v7 header collapse).
 *   - REMOVED the isInHeaderRegion() guard function (now dead code after
 *     buildSearchTypeahead removal; remaining injections target PDP /
 *     product-grid containers only, which never live inside the header).
 *   - REMOVED all `isInHeaderRegion(...)` call sites.
 *   - The header now relies entirely on Symmetry's stock predictive search.
 * Sprint 134 (May 19, 2026): Fix 2 — Shipping accordion text is now
 *   static "Free worldwide shipping" (no country variable). humanizeCountry
 *   is retained as dead-code-safe utility (not invoked).
 *
 * Retained features:
 *   W2.1 Quick Add hardening (collection cards only)
 *   W2.3 Product card extras: swatches + material badge
 *   W2.4 PDP "Browse all {type}" link
 *   W2.5 Country-based delivery accordion on PDP  [Sprint 134: country removed]
 *   W2.6 Brand proof block near PDP buy box  [RESTYLED Sprint 131]
 *   Zero-results page (/search) enhancement
 * ========================================================================== */
(function () {
  'use strict';

  function q(sel, root) { return (root || document).querySelector(sel); }
  function qa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ========================================================================
   * W2.1 — Quick Add production hardening
   * ======================================================================== */
  function quickAddHardening() {
    var REBIND_DELAY = 200;
    var rebindTimer = null;
    function scheduleRebind() {
      if (rebindTimer) clearTimeout(rebindTimer);
      rebindTimer = setTimeout(function () {
        if (typeof window.__bespokyAttachQuickAdd === 'function') {
          try { window.__bespokyAttachQuickAdd(); } catch (e) {}
        }
      }, REBIND_DELAY);
    }

    var gridSelectors = [
      '.product-grid',
      '.collection-listing',
      '.collection-grid',
      'main-collection',
      '[data-product-grid]',
      '.products-grid',
      '.grid--view-items'
    ];
    var grids = [];
    gridSelectors.forEach(function (s) {
      qa(s).forEach(function (el) { if (grids.indexOf(el) === -1) grids.push(el); });
    });

    if (grids.length === 0) return;

    var mo = new MutationObserver(function (muts) {
      var seenNewCard = muts.some(function (m) {
        return Array.prototype.some.call(m.addedNodes || [], function (n) {
          return n.nodeType === 1 && (
            n.tagName === 'PRODUCT-BLOCK' ||
            (n.querySelector && n.querySelector('product-block'))
          );
        });
      });
      if (seenNewCard) scheduleRebind();
    });
    grids.forEach(function (g) { mo.observe(g, { childList: true, subtree: true }); });

    document.body.setAttribute('data-quick-add-debug', 'loaded');

    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.bespoky-quick-add');
      if (!btn) return;
      setTimeout(function () {
        var modal = q('.bespoky-qa-modal.is-open');
        if (!modal && btn.dataset.handle) {
          window.location.href = '/products/' + btn.dataset.handle;
        }
      }, 4000);
    }, true);
  }

  /* ========================================================================
   * Zero-results page enhancement (only on /search template body).
   * ======================================================================== */
  function enhanceZeroResults() {
    if (!/template-search/i.test(document.body.className)) return;
    var noResults = q('.search-no-results, .empty-page-content, [class*="no-results"]');
    if (!noResults) {
      var resultsList = q('.product-grid, .search-results__list');
      if (resultsList && !resultsList.querySelector('product-block, .product-block, .product-card')) {
        var box = document.createElement('div');
        box.className = 'bespoky-search-zero-results';
        box.innerHTML = buildSuggestionHtml();
        resultsList.parentNode.insertBefore(box, resultsList);
      }
      return;
    }
    if (noResults.querySelector('.bespoky-search-zero-results')) return;
    var box2 = document.createElement('div');
    box2.className = 'bespoky-search-zero-results';
    box2.innerHTML = buildSuggestionHtml();
    noResults.appendChild(box2);
  }

  function buildSuggestionHtml() {
    var typoMap = {
      'barfoot': 'barefoot', 'bareffot': 'barefoot', 'barfoot shoes': 'barefoot shoes',
      'chesea': 'chelsea', 'cheslea': 'chelsea',
      'loaffer': 'loafer', 'lofer': 'loafer',
      'sneaker': 'sneakers', 'sneakerz': 'sneakers',
      'oxford': 'oxford shoes'
    };
    var params = new URLSearchParams(window.location.search);
    var qParam = (params.get('q') || '').toLowerCase().trim();
    var didYouMean = '';
    if (qParam && typoMap[qParam]) {
      didYouMean = '<p class="bespoky-did-you-mean">Did you mean <a href="/search?q=' +
        encodeURIComponent(typoMap[qParam]) + '"><strong>' + typoMap[qParam] + '</strong></a>?</p>';
    }
    var suggestions = [
      { label: 'Sneakers', url: '/collections/sneakers' },
      { label: 'Chelsea Boots', url: '/collections/men-boots' },
      { label: 'Slippers', url: '/collections/women-slipper' },
      { label: 'Ballet Flats', url: '/collections/women-sandals-ballets-flat-ballets' },
      { label: 'Loafers', url: '/collections/women-slipper' },
      { label: 'Oxford Shoes', url: '/collections/women-oxford-barefoot-oxford-shoes' }
    ];
    var pills = suggestions.map(function (s) {
      return '<a class="bespoky-search-zero-results__suggestion" href="' + s.url + '">' + s.label + '</a>';
    }).join('');
    var waLink = 'https://wa.me/905324295900?text=' + encodeURIComponent('Hello, I am looking for: ' + (qParam || ''));
    return didYouMean +
           '<h3>Looking for something specific?</h3>' +
           '<p>Try one of our popular categories below:</p>' +
           '<div class="bespoky-search-zero-results__suggestions">' + pills + '</div>' +
           '<p style="margin-top:18px;"><a href="' + waLink + '" target="_blank" rel="noopener" class="bespoky-search-zero-results__suggestion" style="background:#25d366;color:#fff;border-color:#25d366;">Contact us on WhatsApp →</a></p>';
  }

  /* ========================================================================
   * W2.3 — Product card extras
   * ======================================================================== */
  function injectCardExtras() {
    qa('product-block').forEach(function (card) {
      if (card.dataset.bespokyExtrasAttached) return;
      card.dataset.bespokyExtrasAttached = '1';

      var innerer = card.querySelector('.innerer');
      if (!innerer) return;
      if (innerer.querySelector('.bespoky-card-extras')) return;

      var extras = document.createElement('div');
      extras.className = 'bespoky-card-extras';
      var extrasContent = '';

      var swatchItems = card.querySelectorAll('.product-block-options--swatch .product-block-options__item');
      if (swatchItems.length > 0) {
        var swHtml = '';
        var maxShown = Math.min(6, swatchItems.length);
        for (var i = 0; i < maxShown; i++) {
          var sw = swatchItems[i];
          var style = sw.getAttribute('style') || '';
          var bg = '';
          var bgMatch = style.match(/--swatch-background-color:\s*([^;]+)/);
          if (bgMatch) bg = 'background:' + bgMatch[1] + ';';
          else {
            var imgEl = sw.querySelector('img');
            if (imgEl && imgEl.src) bg = 'background-image:url(' + imgEl.src + ');background-size:cover;';
          }
          var name = (sw.getAttribute('data-option-item') || '').replace(/"/g, '&quot;');
          swHtml += '<span class="bespoky-swatch" style="' + bg + '" title="' + name + '" aria-label="' + name + '"></span>';
        }
        var remaining = swatchItems.length - maxShown;
        if (remaining > 0) swHtml += '<span class="bespoky-swatches__more">+' + remaining + '</span>';
        if (swHtml) {
          extrasContent += '<div class="bespoky-card-extras__row"><span class="bespoky-swatches">' + swHtml + '</span></div>';
        }
      }

      var titleEl = card.querySelector('.product-block__title');
      if (titleEl) {
        var title = (titleEl.textContent || '').toLowerCase();
        var material = null;
        if (/suede/.test(title)) material = 'Suede';
        else if (/nubuck/.test(title)) material = 'Nubuck';
        else if (/calf/.test(title)) material = 'Calf Leather';
        else if (/leather/.test(title)) material = 'Leather';
        else if (/shearling|sıcak|fur/.test(title)) material = 'Shearling';
        if (material) {
          extrasContent += '<div class="bespoky-card-extras__row"><span class="bespoky-material-badge">' + material + '</span></div>';
        }
      }

      if (extrasContent) {
        extras.innerHTML = extrasContent;
        var ratingNode = innerer.querySelector('.product-block__rating');
        if (ratingNode) {
          innerer.insertBefore(extras, ratingNode);
        } else {
          innerer.appendChild(extras);
        }
      }
    });
  }

  /* ========================================================================
   * W2.4 — PDP Browse all CTA
   * ======================================================================== */
  function injectBrowseAllPdp() {
    if (!isProductPage()) return;
    if (q('.bespoky-browse-all-link')) return;

    var productType = (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product && window.ShopifyAnalytics.meta.product.type) ||
      detectProductTypeFromBreadcrumb();
    if (!productType) return;

    var slug = productType.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
    if (!slug) return;
    var collectionUrl = '/collections/' + slug;

    var description = q('.product-description, .product__description, [class*="product"][class*="description"]');
    var afterEl = description || q('.product-block-list, .product__info, main');
    if (!afterEl) return;

    var link = document.createElement('a');
    link.className = 'bespoky-browse-all-link';
    link.href = collectionUrl;
    link.textContent = 'Browse all ' + productType + ' →';

    afterEl.parentNode.insertBefore(link, afterEl.nextSibling);
  }

  function isProductPage() {
    return /template-product|product-template/i.test(document.body.className) ||
           !!q('main-product') ||
           !!q('[id*="ProductSection"]') ||
           /^\/products\//.test(window.location.pathname);
  }

  function detectProductTypeFromBreadcrumb() {
    var crumb = qa('.breadcrumb a, [class*="breadcrumb"] a');
    if (!crumb.length) return null;
    for (var i = crumb.length - 1; i >= 0; i--) {
      var text = (crumb[i].textContent || '').trim();
      if (text && !/products?|home/i.test(text)) return text;
    }
    return null;
  }

  /* ========================================================================
   * W2.5 — Shipping accordion (PDP ATC anchored)
   * Sprint 134: text is now static (no country variable)
   * ======================================================================== */
  function injectShippingAccordion() {
    if (!isProductPage()) return;
    if (q('.bespoky-shipping-accordion')) return;

    var atc = q('button.add-to-cart, button[name="add"], .add-to-cart');
    if (!atc) return;

    var details = document.createElement('details');
    details.className = 'bespoky-shipping-accordion';
    details.innerHTML = '' +
      '<summary>📦 Shipping &amp; Returns</summary>' +
      '<ul>' +
      '<li>Free worldwide shipping</li>' +
      '<li>Arrives in <strong>5–7 business days</strong> (5 days handcrafting &middot; 2 days delivery)</li>' +
      '<li>30-day returns &middot; Lifetime craftsmanship warranty</li>' +
      '<li>Made in Turkey &middot; Genuine calf leather</li>' +
      '</ul>';

    var atcRow = atc.closest('.quantity-submit-row, form, product-form') || atc.parentNode;
    if (atcRow && atcRow.parentNode) {
      atcRow.parentNode.insertBefore(details, atcRow);
    }
  }

  function humanizeCountry(code) {
    /* Sprint 134: retained for backward compat; no longer invoked. */
    if (!code) return null;
    var map = {
      'US': 'United States', 'GB': 'United Kingdom', 'UK': 'United Kingdom',
      'CA': 'Canada', 'AU': 'Australia', 'NZ': 'New Zealand',
      'DE': 'Germany', 'FR': 'France', 'IT': 'Italy', 'ES': 'Spain',
      'NL': 'Netherlands', 'BE': 'Belgium', 'SE': 'Sweden', 'NO': 'Norway',
      'DK': 'Denmark', 'FI': 'Finland', 'IE': 'Ireland', 'AT': 'Austria',
      'CH': 'Switzerland', 'PT': 'Portugal', 'GR': 'Greece', 'PL': 'Poland',
      'CZ': 'Czech Republic', 'JP': 'Japan', 'KR': 'South Korea',
      'SG': 'Singapore', 'HK': 'Hong Kong', 'AE': 'UAE', 'SA': 'Saudi Arabia',
      'IL': 'Israel', 'TR': 'Turkey', 'MX': 'Mexico', 'BR': 'Brazil',
      'IN': 'India', 'ZA': 'South Africa'
    };
    return map[code.toUpperCase()] || code;
  }

  /* ========================================================================
   * W2.6 — Brand proof block (PDP ATC anchored)
   * ======================================================================== */
  function injectBrandProof() {
    if (!isProductPage()) return;
    if (q('.bespoky-brand-proof')) return;

    var atc = q('button.add-to-cart, button[name="add"], .add-to-cart');
    if (!atc) return;

    var block = document.createElement('div');
    block.className = 'bespoky-brand-proof';
    block.innerHTML = '' +
      '<div class="bbp-item">' +
      '  <strong><span class="bbp-icon"></span>Made in Turkey</strong>' +
      '  <span>Hand-stitched in Istanbul atelier since 2018</span>' +
      '</div>' +
      '<div class="bbp-item">' +
      '  <strong><span class="bbp-icon"></span>Lifetime Warranty</strong>' +
      '  <span>Craftsmanship guaranteed for the life of the shoe</span>' +
      '</div>' +
      '<div class="bbp-item">' +
      '  <strong><span class="bbp-icon"></span>Premium Calf Leather</strong>' +
      '  <span>Full-grain &middot; Naturally tanned &middot; Soft &amp; durable</span>' +
      '</div>' +
      '<div class="bbp-item">' +
      '  <strong><span class="bbp-icon"></span>4.8 from 4,300+ reviews</strong>' +
      '  <span>Verified buyers via Loox &amp; Etsy</span>' +
      '</div>';

    var trustRow = q('.bespoky-product-trust');
    var anchor = trustRow || atc.closest('.quantity-submit-row, form, product-form') || atc.parentNode;
    if (anchor && anchor.parentNode) {
      anchor.parentNode.insertBefore(block, anchor.nextSibling);
    }
  }

  function init() {
    try { quickAddHardening(); } catch (e) { console.warn('[bespoky-wave2] qa hardening:', e); }
    try { enhanceZeroResults(); } catch (e) { console.warn('[bespoky-wave2] zero-results:', e); }
    try { injectCardExtras(); } catch (e) { console.warn('[bespoky-wave2] card-extras:', e); }
    try { injectBrowseAllPdp(); } catch (e) { console.warn('[bespoky-wave2] browse-all:', e); }
    try { injectShippingAccordion(); } catch (e) { console.warn('[bespoky-wave2] shipping:', e); }
    try { injectBrandProof(); } catch (e) { console.warn('[bespoky-wave2] brand-proof:', e); }

    var gridSelectors = ['.product-grid', '.collection-listing', '.collection-grid',
                          'main-collection', '[data-product-grid]', '.products-grid',
                          '.grid--view-items'];
    gridSelectors.forEach(function (s) {
      qa(s).forEach(function (g) {
        if (g.__bespokyW2Observed) return;
        g.__bespokyW2Observed = true;
        var gObs = new MutationObserver(function () {
          try { injectCardExtras(); } catch (e) {}
        });
        gObs.observe(g, { childList: true, subtree: true });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
